{
  "nl": {
    "aiConverter": {
      "alerts": {
        "dialog": {
          "format": "Markeer beide sprekers met **Naam**: aan het begin van de regel."
        },
        "example": "Wil je een voorbeeld?",
        "truncatedText": "Je bron overschrijdt de limiet van {limit} tekens en kan daarom niet volledig worden verwerkt."
      },
      "buttons": {
        "reuse": "Opnieuw gebruiken",
        "transform": "Omzetten",
        "limitReached": "Limiet bereikt",
        "submitForKind": {
          "audio": "Tekst laten voorlezen",
          "dialog": "Dialoog aanmaken",
          "lecture": "Impulsvortrag aanmaken",
          "podcast": "Podcast aanmaken",
          "summary": "Samenvatting aanmaken",
          "text": "Tekst uit afbeelding of bestand herkennen",
          "transcript": "Transcript aanmaken",
          "translation": "Tekstvertaling"
        }
      },
      "confirm": {
        "deleteDocument": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. Het document wordt permanent uit je geschiedenis verwijderd.",
          "title": "Document verwijderen?"
        }
      },
      "example": {
        "audio": {
          "text": "Olifanten leven in kuddes. Hiertoe behoren echter alleen koeien en jonge dieren, geen volwassen stieren. Zo'n kudde wordt geleid door een ervaren olifantenkoe. De koe beschermt de groep door te laten zien dat ze indien nodig ook zou aanvallen: ze spreidt haar oren wijd en steekt haar slurf omhoog. De volwassen stieren leven meestal alleen of in groepen die steeds weer uiteenvallen en zich opnieuw vormen. Alleen voor de paring naderen ze de kuddes van de koeien. Olifanten zijn pure vegetariërs. Het liefst eten ze gras en bladeren, maar ook takken en andere planten. Ze hebben dagelijks ongeveer 200 kilogram nodig. Daarbij drinken ze meer dan 100 liter water. Olifanten slapen korter dan mensen. Ze hebben al hun tijd nodig om te eten. Daarvoor moeten ze ook heel ver lopen. Ze zijn weliswaar langzaam, maar zeer volhardend. Daarom is het moeilijk om olifanten in een dierentuin te houden, omdat het daar snel te klein voor ze wordt. Bij grote hitte en om hun huid te verzorgen, nemen ze ook graag een bad of spuiten ze met hun slurf water over hun rug. Bij hitte waaieren ze met hun oren en kunnen ze zich zo wat verkoeling verschaffen. (Bron: https://klexikon.zum.de/wiki/Elefanten)"
        },
        "dialog": {
          "dialog": "Voer hier je dialoog in door de sprekers te markeren met **Naam/Rol**: aan het begin van de regel.",
          "text": "**Host**: Hallo! Hoe heet jij?\n**Gast**: Ik heet Anna. En jij?\n**Host**: Ik heet Max. Leuk je te leren kennen.\n**Gast**: Ik ben ook blij."
        },
        "lecture": {
          "prompt": "Concentreer je op de geschiedenis en de politieke achtergrond van Oekraïne en leg het onderwerp uit, passend bij leerlingen van leerjaar 11.",
          "url": "https://nl.wikipedia.org/wiki/Oekra%C3%AFne"
        },
        "podcast": {
          "prompt": "Let op eenvoudige taal voor lerenden op taalniveau A2. Richt je op de leefwereld van jongeren (12-14 jaar) en geef voor hen relevante voorbeelden.",
          "url": "https://thewanderbug.com/itinerary-5-days-new-york-city-first-time/"
        },
        "summary": {
          "url": "https://www.bpb.de/kurz-knapp/hintergrund-aktuell/559432/desinformation-und-wahlen/",
          "prompt": "Concentreer je op de belangrijkste feiten voor leerlingen van leerjaar 10."
        },
        "transcript": {
          "url": "https://www.youtube.com/watch?v=hv0Hz2XMGXA"
        },
        "translation": {
          "text": "De meesten van ons denken bij pinguïns aan een poolsoort, die zich meer thuis voelt op het ijs van Antarctica dan op de zandstranden, grasvelden en heuvels van de Falklands. Maar deze ongelooflijke eilanden in de Zuid-Atlantische Oceaan zijn de thuisbasis van vijf soorten van deze fantastische loopvogels. De zandstranden van de Falklands herbergen de grootste populatie ezelspinguïns ter wereld – tijdens de laatste telling in 2010 werden hier meer dan 121.000 paren geteld! De 76 cm hoge vogels, die het hele jaar door op de Falklands leven, zijn gemakkelijk te herkennen aan de witte streep die over de bovenkant van hun hoofd loopt en hun feloranje snavels. Ze zijn supersnel in zee en zwemmen tot 36 km/u terwijl ze duiken naar vis. En als het tijd is om terug te keren naar het land, rijden ze op de brekers voordat ze op het strand struikelen. In 1971 waren er nog maar 31 broedparen van koningspinguïns bij Volunteer Green op Oost-Falkland, maar vandaag de dag zijn er meer dan 1.500 – het is de op een na grootste en meest toegankelijke kolonie koningspinguïns ter wereld. Gelukkig is dat waar wij naartoe gaan! Duizenden van de meterhoge koningen staan bij elkaar, hun jongen dichtbij in verschillende ontwikkelingsstadia. Sommige volwassenen hebben peervormige witte eieren op hun voeten, andere hebben pasgeboren grijze kuikens tussen hun buikveren. Oudere kuikens hebben hun bruine donsveren gekregen, die een beetje op schapenwol lijken. We luisteren naar het rauwe geroep van de volwassenen terwijl ze hun snavels naar de hemel richten en trompetteren, waarmee ze hun aanwezigheid kenbaar maken. Het is alsof de rechtopstaande, elegante volwassenen poseren voor foto's, hun prachtige oranje-gele nekken en snavels gloeiend in de zonneschijn. Bron: https://www.natgeokids.com/uk/discover/animals/birds/penguins-of-the-falkland-islands/"
        }
      },
      "headings": {
        "config": "Welke inhoud moet de AI gebruiken?",
        "input": "Wat moet de AI voor je doen?",
        "output": "Resultaat"
      },
      "help": {
        "website": "Voorbeeld: https://fobizz.com/was-ist-fobizz/"
      },
      "hints": {
        "audio": "Tip: Je kunt een bestand direct uploaden via drag & drop. We ondersteunen .mp3, .mp4, .mp4a of .wav bestanden tot max. {limit}MB.",
        "copyright": "Let op: Zorg ervoor dat bij het gebruik van andermans inhoud de auteursrechten worden gerespecteerd.",
        "image": "Tip: Je kunt een bestand direct uploaden via drag & drop. We ondersteunen .jpeg, .png tot {limit}MB.",
        "materialGeneration": "Materiaal wordt aangemaakt...",
        "noInputKindSelected": "Kies een invoertype.",
        "pdf": "Upload een ondersteund document tot {limit}MB: PDF, Word, PowerPoint, Excel, OpenDocument, Tekst, Markdown, CSV of HTML.",
        "processingProgressMessage": "Tekst wordt omgezet in audio...",
        "submitting": "Conversie bezig",
        "text": "Tip: Je kunt maximaal 5000 tekens invoeren.",
        "video": "Tip: Je kunt een bestand direct uploaden via drag & drop. We ondersteunen .mp4, .mp4v, .avi of .mkv bestanden tot max. 100MB."
      },
      "labels": {
        "additionalInfo": "Extra informatie en doelgroep",
        "dialog": "Dialooginvoer",
        "language": "Taal",
        "outputLanguage": "Uitvoertaal",
        "outputText": "Uitvoertekst",
        "source": "Bron",
        "text": "Tekstinvoer",
        "transcript": "Transcript",
        "url": "URL",
        "voice": "Stem",
        "voicePlural": "Stemmen",
        "secondVoice": "Tweede stem"
      },
      "links": {
        "download": "Downloaden",
        "openInChat": "Openen in AI Chat"
      },
      "materialExports": {
        "assistant": "AI-Assistent",
        "classroom_screen": "Digitale Tafel",
        "pinboard": "Prikbord",
        "survey": "Enquête",
        "text_document": "Tekstdocument",
        "web_page": "Webpagina",
        "worksheet": "Werkblad"
      },
      "sourceKinds": {
        "audio": "Audio",
        "dialog": "Dialoog",
        "lecture": "Impulsvortrag",
        "podcast": "Podcast",
        "summary": "Samenvatting",
        "text": "Tekst",
        "transcript": "Transcript",
        "translation": "Vertaling"
      },
      "options": {
        "inputKinds": {
          "audio": {
            "icon": "bi-file-music",
            "title": "Audiobestand"
          },
          "image": {
            "icon": "bi-file-image",
            "title": "Afbeelding"
          },
          "pdf": {
            "icon": "bi-file-earmark-text",
            "title": "Bestand"
          },
          "text": {
            "icon": "bi-file-text",
            "title": "Tekst"
          },
          "video": {
            "icon": "bi-film",
            "title": "Videobestand"
          },
          "website": {
            "icon": "bi-globe",
            "title": "Webpagina"
          },
          "youtube": {
            "icon": "bi-youtube",
            "title": "YouTube"
          }
        },
        "languages": {
          "auto": "Automatisch herkennen"
        }
      },
      "paragraphs": {
        "voiceDefaultText": "Hallo, hoe gaat het? Ik ben jouw fobizz AI-Assistent."
      },
      "placeholders": {
        "additionalInfo": "Voeg informatie over de doelgroep toe en benadruk inhoudelijke aspecten die je belangrijk vindt.",
        "website": "Webpagina URL invoeren..."
      },
      "statusMessages": {
        "combine_audio_chunks": "Audiobestand wordt aangemaakt {progress}%",
        "extract_text": "Tekst wordt geëxtraheerd...",
        "generate_audio_file": "Audio wordt aangemaakt {progress}%",
        "generate_dialog": "Dialoog wordt ingesproken {progress}%",
        "generate_lecture": "Impulsvortrag wordt aangemaakt...",
        "generate_podcast": "Podcast wordt aangemaakt...",
        "processing_text_chunks": "Tekstdelen worden verwerkt {progress}%",
        "summarize_text": "Tekst wordt samengevat...",
        "translate_text": "Tekst wordt vertaald...",
        "video_downloading": "Video wordt gedownload {progress}%",
        "video_processing": "Video wordt verwerkt {progress}%"
      }
    }
  }
}
